import React, { useEffect } from 'react'
import useFsVisitorData from './usFsVisitorData';
import { FlagshipProvider, LogLevel, useFlagship, HitType } from '@flagship.io/react-sdk'
import { FLAGSHIP_KEYS ,GROWTHBOOK_FLAGS } from '@mafc/common'
import { useFeature } from '@growthbook/growthbook-react';

export const onLog = (level, tag, message) => {
    if (level === 4)
        // Level value will be 4 only in case of error
        console.error('FLAGSHIP >> ', tag, message)
}
const FlagShipWrapper = (
    { initialVisitorData, initialFlagsData, isSSR, children }

) => {
    
    const isFlagshipEnabled = useFeature(GROWTHBOOK_FLAGS.flagshipEnabled)?.on || false;

    let visitorData = isSSR ? initialVisitorData : useFsVisitorData()
    
    return (
        isFlagshipEnabled ?
            <FlagshipProvider
                envId={FLAGSHIP_KEYS.envKey}
                apiKey={FLAGSHIP_KEYS.apiKey}
                fetchNow={!isSSR}
                visitorData={visitorData}
                initialFlagsData={initialFlagsData}
                onLog={onLog}
            >
                {children}
            </FlagshipProvider> :
            children);

}

export default FlagShipWrapper;